export interface Service {
  id: string;
  name: string;
  shortDesc: string;
  description: string;
  icon: string;
}

export const services: Service[] = [
  {
    id: 'solar',
    name: 'Solar & Energy Optimization',
    shortDesc: 'Reduce bills with clean solar power.',
    description: 'Lower your energy bills and carbon footprint with a top-rated local solar installation. Our vetted pros handle everything from site assessment to full grid-tie installation.',
    icon: 'ri-sun-fill',
  },
  {
    id: 'roofing',
    name: 'Roofing & Exteriors',
    shortDesc: 'Repairs, replacement, and full installs.',
    description: 'Protect your biggest investment with expert roofing repairs, replacements, and inspections. We dispatch pre-vetted local roofers who stand behind their work.',
    icon: 'ri-home-3-fill',
  },
  {
    id: 'hvac',
    name: 'HVAC & Systems',
    shortDesc: 'Heating, cooling, and air quality.',
    description: 'From emergency breakdowns to seasonal tune-ups, our HVAC pros keep you comfortable year-round. Same-day dispatch available for critical system failures.',
    icon: 'ri-temp-cold-line',
  },
  {
    id: 'water',
    name: 'Water & Disaster Cleanup',
    shortDesc: 'Immediate flood & water damage response.',
    description: 'Water damage is a 24/7 emergency. Our certified restoration specialists are on-call to extract water, dry your home, and prevent mold — fast.',
    icon: 'ri-water-flash-fill',
  },
  {
    id: 'safe-living',
    name: 'Safe Living & EMF Mitigation',
    shortDesc: 'Healthier home environments.',
    description: 'Assess and mitigate EMF exposure, improve indoor air quality, and make your home a true sanctuary. Specialists in mold testing, air purification, and EMF shielding.',
    icon: 'ri-shield-check-fill',
  },
  {
    id: 'plumbing',
    name: 'Plumbing & Drains',
    shortDesc: 'Leaks, clogs, and full re-pipes.',
    description: 'From a dripping faucet to a full main-line replacement, our licensed plumbers are ready around the clock. Transparent upfront pricing on every job.',
    icon: 'ri-drop-fill',
  },
];

export const SERVICE_SELECT_OPTIONS = [
  'Solar & Energy Optimization',
  'Roofing & Exteriors',
  'HVAC & Systems',
  'Water & Disaster Cleanup',
  'Safe Living & EMF Mitigation',
  'Plumbing & Drains',
];
